import {PALETTE_IDS} from '#core/application/modules/ids.js';

export function getEventListConfig() {
    const CUSTOM_CONFIG = {
        EventList: {
            eventItem: {
                genericMarketContent: {
                    market: {
                        selectionButton: {
                            view: {
                                contentContainer: {
                                    vertical: {
                                        itemSpacing: '3px',
                                    },
                                },
                            },
                        },
                    },
                },
            },
        },
    };

    return {
        custom: {
            [PALETTE_IDS.EVENT_LIST]: CUSTOM_CONFIG,
        },
    };
}
